import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const abandonedcartAPI = createApi({
  reducerPath: "abandonedcartAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getReportingManagers: builder.query({
      query: () => ({
        url: "/api/accounts/dashboard/get_reporting_managers/",
      }),
    }),
    getAbandonedCartList: builder.query({
      query: (params) => ({
        url: "/api/orders/abandoned-cart/",
        params,
      }),
    }),
    getDownloadAbandonedCartReport: builder.query({
      query: (params) => ({
        url: "api/reports/abandoned-cart",
        params,
      }),
    }),
    getAbandonedCartDetail: builder.query({
      query: (id) => ({
        url: `/api/orders/abandoned-cart/${id}/`,
      }),
    }),
    updateAbandonedCartStatus: builder.mutation({
      query: ({ id, body }) => ({
        url: `/api/orders/abandoned-cart/${id}/update_status/`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetReportingManagersQuery,
  useLazyGetAbandonedCartListQuery,
  useLazyGetDownloadAbandonedCartReportQuery,
  useLazyGetAbandonedCartDetailQuery,
  useUpdateAbandonedCartStatusMutation,
} = abandonedcartAPI;

export default abandonedcartAPI;
